import { put, takeLatest } from "redux-saga/effects";
import API from "api";

import * as ActionTypes from "constants/ActionTypes";
import * as Actions from "actions";

const querystring = require("querystring");

function* adminGetMediaProcessingJobs(action) {
  try {
    const status = action.status || "completed";
    const mediaType = action.mediaType || "all";
    const limit = action.limit || 100;

    const qs = querystring.stringify({
      status,
      media_type: mediaType,
      limit,
    });

    const response = yield API.get(`/admin/product/video-jobs?${qs}`);
    yield put(Actions.adminGetMediaProcessingJobsSuccess(response));
  } catch (error) {
    const msg = (error && error.response && error.response.data && error.response.data.message)
      || (error && error.message)
      || "Failed to load media jobs";
    yield put(Actions.adminGetMediaProcessingJobsFailure(msg));
  }
}

export default function* adminMediaProcessingJobsSaga() {
  yield takeLatest(ActionTypes.ADMIN_GET_MEDIA_PROCESSING_JOBS_START, adminGetMediaProcessingJobs);
}
